import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as accessTokenInfo from "./accessToken";

import authInfo from './modules/auth'
import foodMenus from './modules/foodMenus'
import events from './modules/events'
import subMenu from './modules/subMenu'
import recipe from './modules/recipe'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loading: false,
        
    },
    getters: {
        /*getAutocompleteList: state => {
            return state.autocomplete.data
        }*/
    },
    mutations: {
        changeLoader: state => {
            state.loading = !state.loading
        },
        setOverlayState: state => {
            state.pageOverlay = true
        },
        unsetOverlayState: state => {
            state.pageOverlay = false
        },
    },
    actions: {
        deleteData: ({commit, dispatch}, payload) => {
            
            //console.log(JSON.stringify(payload))
            axios.post(payload.actionPath, payload.data, accessTokenInfo.accessTokenInfo())
            .then(res => {
               
                commit('unsetOverlayState')

                if(res.data.status) {
                    if(payload.payload != null) {
                        dispatch(payload.listActionName, payload.payload)    
                    } else {
                        dispatch(payload.listActionName)    
                    }
                    
                }

            })
            .catch(error => {
                commit('unsetOverlayState')
                console.log(error)
            })
        
        },
        createOrUpdateData: ({commit, dispatch}, payload) => {
               
               commit('setOverlayState')
            
               let submitPayload = {

                    target: payload.target,
                    targetParameters: payload.targetParameters,
                    admin: 0

               }

               let allowed = true

               if(payload.targetAction == 1) {
                
                    if(payload.permissions.access.canEdit == false) {
                        allowed = false
                    }
                    
               } else if(payload.targetAction == 2) {
                    
                    if(payload.permissions.access.canDelete == false) {
                        allowed = false
                    }

               } else if(payload.targetAction == 0) {
                    
                    if(payload.permissions.access.canCreate == false) {
                        allowed = false
                    }
                   
               } 

                if(allowed == true) {
                    dispatch(submitPayload.target, submitPayload.targetParameters).then(() => {
                       /* 
                       dispatch('postActivityLog', 
                            {target_page: submitPayload.target, target_data: JSON.stringify(submitPayload.targetParameters)})
                        */
                    })
                    
                } else {
                    commit('unsetOverlayState')
                }

                commit('setConfirmBoxOff')
        }
    },
    modules: {
        authInfo, foodMenus, events, subMenu, recipe
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js